import { render, staticRenderFns } from "./DevMenu.vue?vue&type=template&id=e0960bea&scoped=true"
import script from "./DevMenu.vue?vue&type=script&lang=js"
export * from "./DevMenu.vue?vue&type=script&lang=js"
import style0 from "./DevMenu.vue?vue&type=style&index=0&id=e0960bea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0960bea",
  null
  
)

export default component.exports